module.exports = __webpack_public_path__ + "media/images/shared/oprah_logo copy-3e9e969652b8247b758e912714c15ef91a2222d400dc663cf006f8ffa8b276b5.png";